<header >
  <div class="d-flex dialog-header">
    <h3 class="dialog-title" translate>
      <fa-icon [icon]="['far', 'file']" transform="shrink-3" class="dialog-title"></fa-icon>
      {{ 'notes' | translate }}
    </h3>
    <ng-container>
      <div class="ml-auto d-flex">
        <ul class="list-inline pull-right">
          <li class="list-inline-item">
            <fieldmagic-primary-button
              (click)="onSubmit()"
              [isInProgress]="bShowLoader"
              icon="save"
              label="save"
            ></fieldmagic-primary-button>
          </li>
          <li class="list-inline-item">
            <fieldmagic-primary-button
              variant="error"
              (click)="closeDialog()"
              icon="times"
              label="close"
            ></fieldmagic-primary-button>
          </li>
        </ul>
      </div>
    </ng-container>
  </div>
</header>
<hr />
<mat-dialog-content>
  <textarea [(ngModel)]="strSchedulerTaskNotes" class="form-control" rows="3"></textarea>
</mat-dialog-content>